import { Divider } from 'antd'
import PerSpacer from '../../Spacer'

export const PerInfoBoxDivider = (): JSX.Element => {
  return (
    <PerSpacer mx="s" className="per-flexRow--fixed fullHeight" testid="spacer">
      <Divider type="vertical" className="fullHeight" />
    </PerSpacer>
  )
}
